import { TabProps } from "shared/types";
import { CustomListDetailsTabEnum } from "../../CustomListDetailsTabEnum";
import { TFunction } from "i18next";

export const getCustomListDetailsTabsConfig = (
  t: TFunction<"translation", undefined>,
) => {
  const config: TabProps[] = [
    {
      value: CustomListDetailsTabEnum.ListItems,
      title: t(
        `customLists:LIST_DETAILS.TABS.${CustomListDetailsTabEnum.ListItems}`,
      ),
    },
    {
      value: CustomListDetailsTabEnum.ListDetails,
      title: t(
        `customLists:LIST_DETAILS.TABS.${CustomListDetailsTabEnum.ListDetails}`,
      ),
    },
    {
      value: CustomListDetailsTabEnum.ListNotes,
      title: t(
        `customLists:LIST_DETAILS.TABS.${CustomListDetailsTabEnum.ListNotes}`,
      ),
    },
    {
      value: CustomListDetailsTabEnum.ListStats,
      title: t(
        `customLists:LIST_DETAILS.TABS.${CustomListDetailsTabEnum.ListStats}`,
      ),
    },
  ];

  return config;
};
